import * as React from 'react'
import { Button, Flex, Popconfirm, Space, Tag } from 'antd'
import { RejectModal } from '../rejectModal'
import { RollbackModal } from '../rollbackModal'
import { submitStatus } from '../../edit/model'
import { role } from '../../../../../libs'
import {
  buttonColorTransactionRequestStatus,
  colorTransactionRequestStatus,
  humanTransactionRequestStatus,
  humanTransactionRequestStatusButton,
  statusDepositFlow,
  transactionRequestStatus,
} from '../../../const'
import { processingProviderName } from '../../../../../libs/processingProvider'
import { Guard } from '../../../../../features/session/guard'
import { GUARD_RULES } from '../../../../../features/session/constants'
import { DepositEdit } from '../../edit/types'

type Props = {
  deposit: DepositEdit
  userRole: string[] | undefined
  actionLoading: boolean
  setIsOpenAdjustmentDepositModal: (open: boolean) => void
}

export const DepositStatusActions = ({
  deposit,
  userRole,
  actionLoading,
  setIsOpenAdjustmentDepositModal,
}: Props) => {
  const isSupport =
    userRole != undefined &&
    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
      userRole.indexOf(role.clientSupport.supportManager()) >= 0)

  const canViewAdjustDeposit =
    ![
      transactionRequestStatus.accepted(),
      transactionRequestStatus.pendingDestination(),
    ].includes(deposit.status) &&
    deposit.processingProvider.toLowerCase() === 'help2pay'

  return (
    <Space size="small" wrap style={{ marginBottom: 12 }}>
      <Tag
        color={colorTransactionRequestStatus(deposit.status)}
        title={deposit.status}
        style={{ margin: 0 }}
      >
        {humanTransactionRequestStatus(deposit.status)}
      </Tag>

      <Guard permission="edit_tranasaction_status">
        <Flex gap="small">
          {!isSupport &&
            statusDepositFlow(deposit.status)?.map((item) => {
              if (
                item == transactionRequestStatus.rollback() &&
                deposit.processingProvider !== processingProviderName.mt5()
              ) {
                return <RollbackModal key={item} request={deposit} />
              }
              if (item == transactionRequestStatus.rejected()) {
                return <RejectModal key={item} request={deposit} />
              }
              if (
                item == transactionRequestStatus.rollback() &&
                deposit.processingProvider == processingProviderName.mt5()
              ) {
                return null
              }
              if (
                deposit.product !== 'nova' ||
                (deposit.product == 'nova' &&
                  item == transactionRequestStatus.accepted() &&
                  (deposit.status ==
                    transactionRequestStatus.pendingManager() ||
                    deposit.status == transactionRequestStatus.ps()))
              ) {
                return (
                  <Button
                    key={item}
                    style={{
                      color: buttonColorTransactionRequestStatus(item).text,
                      backgroundColor:
                        buttonColorTransactionRequestStatus(item).background,
                    }}
                    disabled={actionLoading}
                    loading={actionLoading}
                    onClick={() =>
                      submitStatus({
                        transactionId: deposit.transactionId,
                        status: item,
                      })
                    }
                  >
                    {humanTransactionRequestStatusButton(
                      item,
                      deposit.processingProvider,
                    )}
                  </Button>
                )
              }
              return null
            })}
        </Flex>
      </Guard>

      <Guard permission={GUARD_RULES.CREATE_HELP2PAY_ADJUSTMENT_DEPOSIT}>
        {canViewAdjustDeposit && (
          <Popconfirm
            title="Confirm adjustment creation"
            description="Are you sure you want to create an adjustment deposit?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => setIsOpenAdjustmentDepositModal(true)}
          >
            <Button type="primary">Create Adjustment Deposit</Button>
          </Popconfirm>
        )}
      </Guard>
    </Space>
  )
}
